function _jade_template_fn(locals) {
  locals = locals || {};;;
  var result_of_with = (function($attr, $component, $helpers, Array, JSON, Math, Object, String, hoverTooltip, smartHubDataPoint) {
    var h = require("panel").h;
    var jade_mixins = {},
      $mixins = jade_mixins;
    jade_mixins['slope-svg'] = function(idx, startColor, stopColor, step, nextConvertedBarHeight) {
      var block = (this && this.block),
        attributes = (this && this.attributes) || {};

      return (function() {
        var __jade_nodes = [];
        const {
          value,
          conversionToNext,
          convertedBarHeight
        } = step;;
        const startY = 100 - convertedBarHeight;;
        const endY = 100 - nextConvertedBarHeight;;
        __jade_nodes = __jade_nodes.concat(h("svg", {
          "attrs": {
            viewBox: `0 0 100 100`,
            preserveAspectRatio: `none`,
          },
          "class": {
            'slope': true
          },
        }, (function() {
          var __jade_nodes = [];
          __jade_nodes = __jade_nodes.concat(h("defs", (function() {
            var __jade_nodes = [];
            __jade_nodes = __jade_nodes.concat(h("linearGradient", {
              "attrs": {
                id: `gradient-${idx}`,
                x1: `0%`,
                y1: `0%`,
                x2: `0%`,
                y2: `100%`,
              },
            }, (function() {
              var __jade_nodes = [];
              __jade_nodes = __jade_nodes.concat(h("stop", {
                "attrs": {
                  offset: `0%`
                },
                "style": {
                  'stop-color': startColor,
                  'stop-opacity': 1
                },
              }));
              __jade_nodes = __jade_nodes.concat(h("stop", {
                "attrs": {
                  offset: `100%`
                },
                "style": {
                  'stop-color': stopColor,
                  'stop-opacity': 1
                },
              }));;
              return __jade_nodes
            }).call(this).filter(Boolean)));;
            return __jade_nodes
          }).call(this).filter(Boolean)));
          __jade_nodes = __jade_nodes.concat(h("polygon", {
            "attrs": {
              points: `0,${startY} 100,${endY} 100,100 0,100`
            },
            "style": {
              fill: `url(#gradient-${idx})`
            },
          }));;
          return __jade_nodes
        }).call(this).filter(Boolean)));;
        return __jade_nodes
      }).call(this);
    };

    jade_mixins['bar-tool-tip'] = function(title, color, percentage, count, countType, type, styles) {
      var block = (this && this.block),
        attributes = (this && this.attributes) || {};

      return (function() {
        var __jade_nodes = [];
        __jade_nodes = __jade_nodes.concat(h("div", {
          "style": styles,
          "class": {
            'bar-tooltip-wrapper': true
          },
        }, (function() {
          var __jade_nodes = [];
          __jade_nodes = __jade_nodes.concat(h("mp-chart-tooltip", {
            "attrs": {
              'sections': JSON.stringify($helpers.getTooltipSections(title, percentage, count, countType, type)),
              'title-color': color,
            },
          }));;
          return __jade_nodes
        }).call(this).filter(Boolean)));;
        return __jade_nodes
      }).call(this);
    };

    var __vjadeSafeCode = function(code) {
      return code || String(code);
    };
    const templateRowStyle = $helpers.getTemplateRowStyle();
    const chartHeight = $helpers.getChartHeightStyle();
    return {
      value: (h("div", {
        "on": {
          click: $helpers.unselectBarAndColumn
        },
        "style": {
          '--chart-height': chartHeight,
          '--grid-template-row-style': templateRowStyle,
        },
        "class": {
          'funnel-steps-chart': true
        },
      }, (function() {
        var __jade_nodes = [];
        const startStep = $attr(`start-step`);;
        const steps = $component.overallSteps;;
        const yAxisLabels = $helpers.getYAxisLabels(steps);;
        const {
          startColor,
          stopColor
        } = $helpers.getSlopeColor();;
        __jade_nodes = __jade_nodes.concat(h("div", {
          "class": {
            'smart-hub-data-points': true
          },
        }, (function() {
          var __jade_nodes = [];
          __jade_nodes = __jade_nodes.concat((smartHubDataPoint) ? ((function() {
            var __jade_nodes = [];
            const alert = smartHubDataPoint.alert;;
            const placement = $helpers.smartHubAlertPlacement(smartHubDataPoint.index);;
            __jade_nodes = __jade_nodes.concat(h("mp-smart-hub-data-point", {
              "attrs": {
                'alert': JSON.stringify(alert),
                'project-id': $attr(`project-id`),
                'utc-offset': $attr(`utc-offset`),
                'placement': placement,
                'open': 'true',
                'workspace-id': $attr(`workspace-id`),
              },
              "on": {
                change: $helpers.smartHubAlertChange
              },
              "style": {
                top: `${smartHubDataPoint.top}px`,
                left: `${smartHubDataPoint.left}px`
              },
            }));;
            return __jade_nodes
          }).call(this)) : undefined);;
          return __jade_nodes
        }).call(this).filter(Boolean)));
        const noData = !$attr(`loading`) && steps.length === 0;
        __jade_nodes = __jade_nodes.concat(h("div", {
          "class": Object.assign({}, {
            griddable: !noData
          }, {
            'graph': true
          }),
        }, (function() {
          var __jade_nodes = [];
          __jade_nodes = __jade_nodes.concat((noData) ? ((function() {
            var __jade_nodes = [];
            __jade_nodes = __jade_nodes.concat(h("slot", {
              "attrs": {
                name: `empty-state`
              },
            }));;
            return __jade_nodes
          }).call(this)) : ((function() {
            var __jade_nodes = [];
            __jade_nodes = __jade_nodes.concat(h("div", {
              "class": {
                'y-axis-container': true
              },
            }, (function() {
              var __jade_nodes = [];
              __jade_nodes = __jade_nodes.concat(h("div", {
                "class": {
                  'y-axis-label-header': true
                },
              }, (function() {
                var __jade_nodes = [];
                __jade_nodes = __jade_nodes.concat(($attr(`show-conversion-rate`)) ? ((function() {
                  var __jade_nodes = [];
                  __jade_nodes = __jade_nodes.concat(h("div", {
                    "class": {
                      'completion-rate': true
                    },
                  }, (function() {
                    var __jade_nodes = [];
                    __jade_nodes = __jade_nodes.concat($helpers.getUserCount());
                    __jade_nodes = __jade_nodes.concat(h("div", {
                      "class": {
                        'percentage': true
                      },
                    }, [__vjadeSafeCode($helpers.getUserConversionRate())]));;
                    return __jade_nodes
                  }).call(this).filter(Boolean)));;
                  return __jade_nodes
                }).call(this)) : undefined);;
                return __jade_nodes
              }).call(this).filter(Boolean)));
              __jade_nodes = __jade_nodes.concat(h("div", {
                "class": {
                  'y-axis-count-header': true
                },
              }));
              __jade_nodes = __jade_nodes.concat(h("div", {
                "class": {
                  'y-axis-labels': true
                },
              }, (function() {
                var __jade_nodes = [];
                __jade_nodes = __jade_nodes.concat((function() {
                  var $$obj = (yAxisLabels);
                  var $$eachNodes;
                  var $$iterated = false;
                  if (Array.isArray($$obj)) {
                    $$eachNodes = $$obj.reduce(function($$eachNodes, label, $index) {
                      $$iterated = true;
                      return $$eachNodes.concat((function() {
                        var __jade_nodes = [];
                        __jade_nodes = __jade_nodes.concat(h("div", {
                          "style": {
                            'bottom': `${label.y * 100}%`
                          },
                          "class": {
                            'axis-label': true
                          },
                        }, [__vjadeSafeCode(label.text)]));;
                        return __jade_nodes
                      }).call(this));
                    }, []);
                  } else {
                    $$eachNodes = [];
                    for (var $$objKey in $$obj) {
                      (function() {
                        var $index = $$objKey;
                        if ($$obj.hasOwnProperty($index)) {
                          $$iterated = true;
                          var label = $$obj[$index];
                          $$eachNodes = $$eachNodes.concat((function() {
                            var __jade_nodes = [];
                            __jade_nodes = __jade_nodes.concat(h("div", {
                              "style": {
                                'bottom': `${label.y * 100}%`
                              },
                              "class": {
                                'axis-label': true
                              },
                            }, [__vjadeSafeCode(label.text)]));;
                            return __jade_nodes
                          }).call(this));
                        }
                      })();
                    }
                  }

                  return $$eachNodes;
                })());;
                return __jade_nodes
              }).call(this).filter(Boolean)));;
              return __jade_nodes
            }).call(this).filter(Boolean)));
            __jade_nodes = __jade_nodes.concat(h("div", {
              "class": {
                'y-axis-lines': true
              },
            }, (function() {
              var __jade_nodes = [];
              __jade_nodes = __jade_nodes.concat((function() {
                var $$obj = (yAxisLabels);
                var $$eachNodes;
                var $$iterated = false;
                if (Array.isArray($$obj)) {
                  $$eachNodes = $$obj.reduce(function($$eachNodes, label, $index) {
                    $$iterated = true;
                    return $$eachNodes.concat((function() {
                      var __jade_nodes = [];
                      __jade_nodes = __jade_nodes.concat(h("div", {
                        "style": {
                          'bottom': `${$helpers.CHART_BAR_HEIGHT * label.y}px`
                        },
                        "class": {
                          'axis-line': true
                        },
                      }));;
                      return __jade_nodes
                    }).call(this));
                  }, []);
                } else {
                  $$eachNodes = [];
                  for (var $$objKey in $$obj) {
                    (function() {
                      var $index = $$objKey;
                      if ($$obj.hasOwnProperty($index)) {
                        $$iterated = true;
                        var label = $$obj[$index];
                        $$eachNodes = $$eachNodes.concat((function() {
                          var __jade_nodes = [];
                          __jade_nodes = __jade_nodes.concat(h("div", {
                            "style": {
                              'bottom': `${$helpers.CHART_BAR_HEIGHT * label.y}px`
                            },
                            "class": {
                              'axis-line': true
                            },
                          }));;
                          return __jade_nodes
                        }).call(this));
                      }
                    })();
                  }
                }

                return $$eachNodes;
              })());;
              return __jade_nodes
            }).call(this).filter(Boolean)));
            __jade_nodes = __jade_nodes.concat(h("div", {
              "on": {
                scroll: $helpers.handleScroll,
                wheel: $helpers.trackScroll,
              },
              "style": $helpers.getVariableColumnStyles(),
              "class": {
                'columns': true
              },
            }, (function() {
              var __jade_nodes = [];
              const hasMultipleSeries = $component.hasMultipleSeries;
              __jade_nodes = __jade_nodes.concat((function() {
                var $$obj = (steps);
                var $$eachNodes;
                var $$iterated = false;
                if (Array.isArray($$obj)) {
                  $$eachNodes = $$obj.reduce(function($$eachNodes, step, idx) {
                    $$iterated = true;
                    return $$eachNodes.concat((function() {
                      var __jade_nodes = [];
                      __jade_nodes = __jade_nodes.concat(h("div", {
                        "on": {
                          click: () => $attr(`disable-header-click`) ? null : $helpers.selectColumn(idx)
                        },
                        "class": Object.assign({}, {
                          'is-clickable': $attr(`disable-header-click`) === false,
                          'selected': $attr(`selected-column`) === idx,
                          'unselected': $helpers.isUnselected(idx),
                        }, {
                          'step-label-header': true
                        }),
                      }, (function() {
                        var __jade_nodes = [];
                        __jade_nodes = __jade_nodes.concat(h("div", {
                          "class": {
                            'step-label': true
                          },
                        }, (function() {
                          var __jade_nodes = [];
                          __jade_nodes = __jade_nodes.concat(h("div", {
                            "class": {
                              'label-wrapper': true
                            },
                          }, (function() {
                            var __jade_nodes = [];
                            __jade_nodes = __jade_nodes.concat(h("div", {
                              "class": {
                                'title-wrapper': true
                              },
                            }, (function() {
                              var __jade_nodes = [];
                              __jade_nodes = __jade_nodes.concat(h("div", {
                                "class": {
                                  'title': true
                                },
                              }, [__vjadeSafeCode(`${idx + 1}. ${step.title}`)]));;
                              return __jade_nodes
                            }).call(this).filter(Boolean)));
                            __jade_nodes = __jade_nodes.concat((step.subheader) ? ((function() {
                              var __jade_nodes = [];
                              __jade_nodes = __jade_nodes.concat(h("div", {
                                "class": {
                                  'subheader': true
                                },
                              }, [__vjadeSafeCode(step.subheader)]));;
                              return __jade_nodes
                            }).call(this)) : undefined);;
                            return __jade_nodes
                          }).call(this).filter(Boolean)));
                          const displayTooltip = step.title.length > 25 || (step.subheader && step.subheader.length > 25);
                          __jade_nodes = __jade_nodes.concat((step.tooltipText && displayTooltip) ? ((function() {
                            var __jade_nodes = [];
                            __jade_nodes = __jade_nodes.concat(h("mp-tooltip", {
                              "attrs": {
                                placement: `bottom`,
                                'max-width': `300px`
                              },
                            }, (function() {
                              var __jade_nodes = [];
                              __jade_nodes = __jade_nodes.concat(h("span", {
                                "class": {
                                  'tooltip-text': true
                                },
                              }, [__vjadeSafeCode(step.tooltipText)]));;
                              return __jade_nodes
                            }).call(this).filter(Boolean)));;
                            return __jade_nodes
                          }).call(this)) : undefined);;
                          return __jade_nodes
                        }).call(this).filter(Boolean)));;
                        return __jade_nodes
                      }).call(this).filter(Boolean)));
                      const hasMultipleSeries = $component.hasMultipleSeries;
                      __jade_nodes = __jade_nodes.concat(h("div", {
                        "class": {
                          'step-count-header': true
                        },
                      }, (function() {
                        var __jade_nodes = [];
                        __jade_nodes = __jade_nodes.concat((!step.empty && !hasMultipleSeries) ? ((function() {
                          var __jade_nodes = [];
                          __jade_nodes = __jade_nodes.concat(h("div", {
                            "class": Object.assign({}, {
                              'unselected': $helpers.isUnselected(idx)
                            }, {
                              'value': true
                            }),
                          }, [__vjadeSafeCode($helpers.countHeader(step))]));;
                          return __jade_nodes
                        }).call(this)) : undefined);;
                        return __jade_nodes
                      }).call(this).filter(Boolean)));
                      __jade_nodes = __jade_nodes.concat(h("div", {
                        "on": {
                          contextmenu: ev => $helpers.contextMenu(ev, step)
                        },
                        "class": Object.assign({}, {
                          'is-empty': step.empty,
                          'no-context-menu': $attr(`disable-context-menu`),
                        }, {
                          'step': true
                        }),
                      }, (function() {
                        var __jade_nodes = []; /*  step child elements are ordered by implicit z-index */
                        const firstBarInStep = $helpers.firstBarInStep(step);
                        const hasConversionToNext = $helpers.hasConversionToNext(step);
                        __jade_nodes = __jade_nodes.concat((hasConversionToNext) ? ((function() {
                          var __jade_nodes = [];
                          const nextBar = $helpers.firstBarInStep(steps[idx + 1]);
                          __jade_nodes = __jade_nodes.concat(jade_mixins['slope-svg'].call(this, idx, startColor, stopColor, firstBarInStep, nextBar.convertedBarHeight));;
                          return __jade_nodes
                        }).call(this)) : undefined);
                        __jade_nodes = __jade_nodes.concat((hasConversionToNext && !step.empty) ? ((function() {
                          var __jade_nodes = [];
                          const alertForStep = $helpers.getAlertForStep(idx);
                          __jade_nodes = __jade_nodes.concat(h("div", {
                            "style": $helpers.conversionArrowStyles(firstBarInStep, idx),
                            "class": Object.assign({}, {
                              'smart-hub-data-point': Boolean(alertForStep)
                            }, {
                              'conversion-arrow': true
                            }),
                          }, (function() {
                            var __jade_nodes = [];
                            __jade_nodes = __jade_nodes.concat("" + ($helpers.formatPercent(firstBarInStep.conversionToNext, 1)) + "");
                            __jade_nodes = __jade_nodes.concat((alertForStep) ? ((function() {
                              var __jade_nodes = [];
                              __jade_nodes = __jade_nodes.concat(h("div", {
                                "on": {
                                  click: $helpers.clickSmartHubDataPoint(idx, alertForStep)
                                },
                                "class": {
                                  'smart-hub-alert-data-point-placeholder': true
                                },
                              }, (function() {
                                var __jade_nodes = [];
                                __jade_nodes = __jade_nodes.concat(h("div", {
                                  "class": {
                                    'smart-hub-alert-data-point-marker': true
                                  },
                                }));;
                                return __jade_nodes
                              }).call(this).filter(Boolean)));;
                              return __jade_nodes
                            }).call(this)) : undefined);
                            __jade_nodes = __jade_nodes.concat(h("div", {
                              "class": {
                                'conversion-arrow-triangle': true
                              },
                            }));;
                            return __jade_nodes
                          }).call(this).filter(Boolean)));;
                          return __jade_nodes
                        }).call(this)) : undefined);
                        __jade_nodes = __jade_nodes.concat((!step.empty) ? ((function() {
                          var __jade_nodes = [];
                          const dividerSize = 1;
                          __jade_nodes = __jade_nodes.concat(h("div", {
                            "class": {
                              'bars-wrapper': true
                            },
                          }, (function() {
                            var __jade_nodes = [];
                            __jade_nodes = __jade_nodes.concat((function() {
                              var $$obj = (step.data);
                              var $$eachNodes;
                              var $$iterated = false;
                              if (Array.isArray($$obj)) {
                                $$eachNodes = $$obj.reduce(function($$eachNodes, bar, barIdx) {
                                  $$iterated = true;
                                  return $$eachNodes.concat((function() {
                                    var __jade_nodes = [];
                                    __jade_nodes = __jade_nodes.concat(h("div", {
                                      "class": Object.assign({}, {
                                        'multi-bar': hasMultipleSeries
                                      }, {
                                        'bar-wrapper': true
                                      }),
                                    }, (function() {
                                      var __jade_nodes = [];
                                      const hasDropOff = !$attr(`disable-drop-off-viz`) && $helpers.hasDropOff(idx, barIdx, step);
                                      __jade_nodes = __jade_nodes.concat((hasMultipleSeries) ? ((function() {
                                        var __jade_nodes = [];
                                        const barHeight = Math.min(bar.convertedBarHeight + bar.dropOffBarHeight, 100);
                                        __jade_nodes = __jade_nodes.concat(h("div", {
                                          "style": {
                                            top: `calc(${100 - (barHeight)}% - 20px)`,
                                          },
                                          "class": {
                                            'count-text': true
                                          },
                                        }, [__vjadeSafeCode($helpers.abbreviateNumber3SigFigs(bar.value))]));;
                                        return __jade_nodes
                                      }).call(this)) : undefined);
                                      const {
                                        title,
                                        conversionCount,
                                        conversionPercentage,
                                        dropOffCount,
                                        dropOffPercentage,
                                        type,
                                        countType
                                      } = $helpers.getTooltipData(idx, barIdx, bar);
                                      const color = bar.color || $helpers.getColor(barIdx, $helpers.BarType.CONVERTED);
                                      __jade_nodes = __jade_nodes.concat((hasDropOff) ? ((function() {
                                        var __jade_nodes = [];
                                        __jade_nodes = __jade_nodes.concat(h("div", {
                                          "style": {
                                            height: `calc(${bar.dropOffBarHeight}% - ${dividerSize}px)`,
                                            bottom: `calc(${bar.convertedBarHeight}% + ${dividerSize}px)`,
                                            '--color': bar.color || $helpers.getColor(barIdx, $helpers.BarType.DROP_OFF),
                                          },
                                          "on": {
                                            click: $helpers.selectBar(idx, barIdx, $helpers.BarType.DROP_OFF),
                                            mousemove: ev => $helpers.handleMouseMove(idx, barIdx, $helpers.BarType.DROP_OFF, ev),
                                            mouseleave: $helpers.handleMouseLeave,
                                          },
                                          "class": Object.assign({}, {
                                            'selected': $helpers.isSelected(idx, barIdx, $helpers.BarType.DROP_OFF),
                                            'unselected': $helpers.isUnselected(idx),
                                            'is-not-clickable': $attr(`disable-drop-off-click`),
                                            'highlighted': $helpers.isHighlighted(idx, barIdx, $helpers.BarType.DROP_OFF),
                                            'has-drop-off': true,
                                            'multi-bar': hasMultipleSeries,
                                          }, {
                                            'drop-off-bar': true
                                          }),
                                        }, (function() {
                                          var __jade_nodes = [];
                                          __jade_nodes = __jade_nodes.concat(($helpers.shouldShowTooltip(idx, barIdx, $helpers.BarType.DROP_OFF) && dropOffCount) ? ((function() {
                                            var __jade_nodes = [];
                                            __jade_nodes = __jade_nodes.concat(jade_mixins['bar-tool-tip'].call(this, title, color, dropOffPercentage, dropOffCount, countType, $helpers.BarType.DROP_OFF, hoverTooltip.styles));;
                                            return __jade_nodes
                                          }).call(this)) : undefined);;
                                          return __jade_nodes
                                        }).call(this).filter(Boolean)));;
                                        return __jade_nodes
                                      }).call(this)) : undefined);
                                      __jade_nodes = __jade_nodes.concat(h("div", {
                                        "style": {
                                          height: `${bar.convertedBarHeight}%`,
                                          '--color': bar.color || $helpers.getColor(barIdx, $helpers.BarType.CONVERTED),
                                        },
                                        "on": {
                                          click: $helpers.selectBar(idx, barIdx, $helpers.BarType.CONVERTED),
                                          mousemove: ev => $helpers.handleMouseMove(idx, barIdx, $helpers.BarType.CONVERTED, ev),
                                          mouseleave: $helpers.handleMouseLeave,
                                        },
                                        "class": Object.assign({}, {
                                          'selected': $helpers.isSelected(idx, barIdx, $helpers.BarType.CONVERTED),
                                          'unselected': $helpers.isUnselected(idx),
                                          'is-not-clickable': $attr(`disable-step-click`),
                                          'highlighted': $helpers.isHighlighted(idx, barIdx, $helpers.BarType.CONVERTED),
                                          'has-drop-off': !hasDropOff,
                                          'multi-bar': hasMultipleSeries,
                                        }, {
                                          'bar': true
                                        }),
                                      }, (function() {
                                        var __jade_nodes = [];
                                        __jade_nodes = __jade_nodes.concat(($helpers.shouldShowTooltip(idx, barIdx, $helpers.BarType.CONVERTED)) ? ((function() {
                                          var __jade_nodes = [];
                                          __jade_nodes = __jade_nodes.concat(jade_mixins['bar-tool-tip'].call(this, title, color, conversionPercentage, conversionCount, countType, $helpers.BarType.CONVERTED, hoverTooltip.styles));;
                                          return __jade_nodes
                                        }).call(this)) : undefined);;
                                        return __jade_nodes
                                      }).call(this).filter(Boolean)));;
                                      return __jade_nodes
                                    }).call(this).filter(Boolean)));;
                                    return __jade_nodes
                                  }).call(this));
                                }, []);
                              } else {
                                $$eachNodes = [];
                                for (var $$objKey in $$obj) {
                                  (function() {
                                    var barIdx = $$objKey;
                                    if ($$obj.hasOwnProperty(barIdx)) {
                                      $$iterated = true;
                                      var bar = $$obj[barIdx];
                                      $$eachNodes = $$eachNodes.concat((function() {
                                        var __jade_nodes = [];
                                        __jade_nodes = __jade_nodes.concat(h("div", {
                                          "class": Object.assign({}, {
                                            'multi-bar': hasMultipleSeries
                                          }, {
                                            'bar-wrapper': true
                                          }),
                                        }, (function() {
                                          var __jade_nodes = [];
                                          const hasDropOff = !$attr(`disable-drop-off-viz`) && $helpers.hasDropOff(idx, barIdx, step);
                                          __jade_nodes = __jade_nodes.concat((hasMultipleSeries) ? ((function() {
                                            var __jade_nodes = [];
                                            const barHeight = Math.min(bar.convertedBarHeight + bar.dropOffBarHeight, 100);
                                            __jade_nodes = __jade_nodes.concat(h("div", {
                                              "style": {
                                                top: `calc(${100 - (barHeight)}% - 20px)`,
                                              },
                                              "class": {
                                                'count-text': true
                                              },
                                            }, [__vjadeSafeCode($helpers.abbreviateNumber3SigFigs(bar.value))]));;
                                            return __jade_nodes
                                          }).call(this)) : undefined);
                                          const {
                                            title,
                                            conversionCount,
                                            conversionPercentage,
                                            dropOffCount,
                                            dropOffPercentage,
                                            type,
                                            countType
                                          } = $helpers.getTooltipData(idx, barIdx, bar);
                                          const color = bar.color || $helpers.getColor(barIdx, $helpers.BarType.CONVERTED);
                                          __jade_nodes = __jade_nodes.concat((hasDropOff) ? ((function() {
                                            var __jade_nodes = [];
                                            __jade_nodes = __jade_nodes.concat(h("div", {
                                              "style": {
                                                height: `calc(${bar.dropOffBarHeight}% - ${dividerSize}px)`,
                                                bottom: `calc(${bar.convertedBarHeight}% + ${dividerSize}px)`,
                                                '--color': bar.color || $helpers.getColor(barIdx, $helpers.BarType.DROP_OFF),
                                              },
                                              "on": {
                                                click: $helpers.selectBar(idx, barIdx, $helpers.BarType.DROP_OFF),
                                                mousemove: ev => $helpers.handleMouseMove(idx, barIdx, $helpers.BarType.DROP_OFF, ev),
                                                mouseleave: $helpers.handleMouseLeave,
                                              },
                                              "class": Object.assign({}, {
                                                'selected': $helpers.isSelected(idx, barIdx, $helpers.BarType.DROP_OFF),
                                                'unselected': $helpers.isUnselected(idx),
                                                'is-not-clickable': $attr(`disable-drop-off-click`),
                                                'highlighted': $helpers.isHighlighted(idx, barIdx, $helpers.BarType.DROP_OFF),
                                                'has-drop-off': true,
                                                'multi-bar': hasMultipleSeries,
                                              }, {
                                                'drop-off-bar': true
                                              }),
                                            }, (function() {
                                              var __jade_nodes = [];
                                              __jade_nodes = __jade_nodes.concat(($helpers.shouldShowTooltip(idx, barIdx, $helpers.BarType.DROP_OFF) && dropOffCount) ? ((function() {
                                                var __jade_nodes = [];
                                                __jade_nodes = __jade_nodes.concat(jade_mixins['bar-tool-tip'].call(this, title, color, dropOffPercentage, dropOffCount, countType, $helpers.BarType.DROP_OFF, hoverTooltip.styles));;
                                                return __jade_nodes
                                              }).call(this)) : undefined);;
                                              return __jade_nodes
                                            }).call(this).filter(Boolean)));;
                                            return __jade_nodes
                                          }).call(this)) : undefined);
                                          __jade_nodes = __jade_nodes.concat(h("div", {
                                            "style": {
                                              height: `${bar.convertedBarHeight}%`,
                                              '--color': bar.color || $helpers.getColor(barIdx, $helpers.BarType.CONVERTED),
                                            },
                                            "on": {
                                              click: $helpers.selectBar(idx, barIdx, $helpers.BarType.CONVERTED),
                                              mousemove: ev => $helpers.handleMouseMove(idx, barIdx, $helpers.BarType.CONVERTED, ev),
                                              mouseleave: $helpers.handleMouseLeave,
                                            },
                                            "class": Object.assign({}, {
                                              'selected': $helpers.isSelected(idx, barIdx, $helpers.BarType.CONVERTED),
                                              'unselected': $helpers.isUnselected(idx),
                                              'is-not-clickable': $attr(`disable-step-click`),
                                              'highlighted': $helpers.isHighlighted(idx, barIdx, $helpers.BarType.CONVERTED),
                                              'has-drop-off': !hasDropOff,
                                              'multi-bar': hasMultipleSeries,
                                            }, {
                                              'bar': true
                                            }),
                                          }, (function() {
                                            var __jade_nodes = [];
                                            __jade_nodes = __jade_nodes.concat(($helpers.shouldShowTooltip(idx, barIdx, $helpers.BarType.CONVERTED)) ? ((function() {
                                              var __jade_nodes = [];
                                              __jade_nodes = __jade_nodes.concat(jade_mixins['bar-tool-tip'].call(this, title, color, conversionPercentage, conversionCount, countType, $helpers.BarType.CONVERTED, hoverTooltip.styles));;
                                              return __jade_nodes
                                            }).call(this)) : undefined);;
                                            return __jade_nodes
                                          }).call(this).filter(Boolean)));;
                                          return __jade_nodes
                                        }).call(this).filter(Boolean)));;
                                        return __jade_nodes
                                      }).call(this));
                                    }
                                  })();
                                }
                              }

                              return $$eachNodes;
                            })());;
                            return __jade_nodes
                          }).call(this).filter(Boolean)));;
                          return __jade_nodes
                        }).call(this)) : undefined);;
                        return __jade_nodes
                      }).call(this).filter(Boolean)));;
                      return __jade_nodes
                    }).call(this));
                  }, []);
                } else {
                  $$eachNodes = [];
                  for (var $$objKey in $$obj) {
                    (function() {
                      var idx = $$objKey;
                      if ($$obj.hasOwnProperty(idx)) {
                        $$iterated = true;
                        var step = $$obj[idx];
                        $$eachNodes = $$eachNodes.concat((function() {
                          var __jade_nodes = [];
                          __jade_nodes = __jade_nodes.concat(h("div", {
                            "on": {
                              click: () => $attr(`disable-header-click`) ? null : $helpers.selectColumn(idx)
                            },
                            "class": Object.assign({}, {
                              'is-clickable': $attr(`disable-header-click`) === false,
                              'selected': $attr(`selected-column`) === idx,
                              'unselected': $helpers.isUnselected(idx),
                            }, {
                              'step-label-header': true
                            }),
                          }, (function() {
                            var __jade_nodes = [];
                            __jade_nodes = __jade_nodes.concat(h("div", {
                              "class": {
                                'step-label': true
                              },
                            }, (function() {
                              var __jade_nodes = [];
                              __jade_nodes = __jade_nodes.concat(h("div", {
                                "class": {
                                  'label-wrapper': true
                                },
                              }, (function() {
                                var __jade_nodes = [];
                                __jade_nodes = __jade_nodes.concat(h("div", {
                                  "class": {
                                    'title-wrapper': true
                                  },
                                }, (function() {
                                  var __jade_nodes = [];
                                  __jade_nodes = __jade_nodes.concat(h("div", {
                                    "class": {
                                      'title': true
                                    },
                                  }, [__vjadeSafeCode(`${idx + 1}. ${step.title}`)]));;
                                  return __jade_nodes
                                }).call(this).filter(Boolean)));
                                __jade_nodes = __jade_nodes.concat((step.subheader) ? ((function() {
                                  var __jade_nodes = [];
                                  __jade_nodes = __jade_nodes.concat(h("div", {
                                    "class": {
                                      'subheader': true
                                    },
                                  }, [__vjadeSafeCode(step.subheader)]));;
                                  return __jade_nodes
                                }).call(this)) : undefined);;
                                return __jade_nodes
                              }).call(this).filter(Boolean)));
                              const displayTooltip = step.title.length > 25 || (step.subheader && step.subheader.length > 25);
                              __jade_nodes = __jade_nodes.concat((step.tooltipText && displayTooltip) ? ((function() {
                                var __jade_nodes = [];
                                __jade_nodes = __jade_nodes.concat(h("mp-tooltip", {
                                  "attrs": {
                                    placement: `bottom`,
                                    'max-width': `300px`
                                  },
                                }, (function() {
                                  var __jade_nodes = [];
                                  __jade_nodes = __jade_nodes.concat(h("span", {
                                    "class": {
                                      'tooltip-text': true
                                    },
                                  }, [__vjadeSafeCode(step.tooltipText)]));;
                                  return __jade_nodes
                                }).call(this).filter(Boolean)));;
                                return __jade_nodes
                              }).call(this)) : undefined);;
                              return __jade_nodes
                            }).call(this).filter(Boolean)));;
                            return __jade_nodes
                          }).call(this).filter(Boolean)));
                          const hasMultipleSeries = $component.hasMultipleSeries;
                          __jade_nodes = __jade_nodes.concat(h("div", {
                            "class": {
                              'step-count-header': true
                            },
                          }, (function() {
                            var __jade_nodes = [];
                            __jade_nodes = __jade_nodes.concat((!step.empty && !hasMultipleSeries) ? ((function() {
                              var __jade_nodes = [];
                              __jade_nodes = __jade_nodes.concat(h("div", {
                                "class": Object.assign({}, {
                                  'unselected': $helpers.isUnselected(idx)
                                }, {
                                  'value': true
                                }),
                              }, [__vjadeSafeCode($helpers.countHeader(step))]));;
                              return __jade_nodes
                            }).call(this)) : undefined);;
                            return __jade_nodes
                          }).call(this).filter(Boolean)));
                          __jade_nodes = __jade_nodes.concat(h("div", {
                            "on": {
                              contextmenu: ev => $helpers.contextMenu(ev, step)
                            },
                            "class": Object.assign({}, {
                              'is-empty': step.empty,
                              'no-context-menu': $attr(`disable-context-menu`),
                            }, {
                              'step': true
                            }),
                          }, (function() {
                            var __jade_nodes = []; /*  step child elements are ordered by implicit z-index */
                            const firstBarInStep = $helpers.firstBarInStep(step);
                            const hasConversionToNext = $helpers.hasConversionToNext(step);
                            __jade_nodes = __jade_nodes.concat((hasConversionToNext) ? ((function() {
                              var __jade_nodes = [];
                              const nextBar = $helpers.firstBarInStep(steps[idx + 1]);
                              __jade_nodes = __jade_nodes.concat(jade_mixins['slope-svg'].call(this, idx, startColor, stopColor, firstBarInStep, nextBar.convertedBarHeight));;
                              return __jade_nodes
                            }).call(this)) : undefined);
                            __jade_nodes = __jade_nodes.concat((hasConversionToNext && !step.empty) ? ((function() {
                              var __jade_nodes = [];
                              const alertForStep = $helpers.getAlertForStep(idx);
                              __jade_nodes = __jade_nodes.concat(h("div", {
                                "style": $helpers.conversionArrowStyles(firstBarInStep, idx),
                                "class": Object.assign({}, {
                                  'smart-hub-data-point': Boolean(alertForStep)
                                }, {
                                  'conversion-arrow': true
                                }),
                              }, (function() {
                                var __jade_nodes = [];
                                __jade_nodes = __jade_nodes.concat("" + ($helpers.formatPercent(firstBarInStep.conversionToNext, 1)) + "");
                                __jade_nodes = __jade_nodes.concat((alertForStep) ? ((function() {
                                  var __jade_nodes = [];
                                  __jade_nodes = __jade_nodes.concat(h("div", {
                                    "on": {
                                      click: $helpers.clickSmartHubDataPoint(idx, alertForStep)
                                    },
                                    "class": {
                                      'smart-hub-alert-data-point-placeholder': true
                                    },
                                  }, (function() {
                                    var __jade_nodes = [];
                                    __jade_nodes = __jade_nodes.concat(h("div", {
                                      "class": {
                                        'smart-hub-alert-data-point-marker': true
                                      },
                                    }));;
                                    return __jade_nodes
                                  }).call(this).filter(Boolean)));;
                                  return __jade_nodes
                                }).call(this)) : undefined);
                                __jade_nodes = __jade_nodes.concat(h("div", {
                                  "class": {
                                    'conversion-arrow-triangle': true
                                  },
                                }));;
                                return __jade_nodes
                              }).call(this).filter(Boolean)));;
                              return __jade_nodes
                            }).call(this)) : undefined);
                            __jade_nodes = __jade_nodes.concat((!step.empty) ? ((function() {
                              var __jade_nodes = [];
                              const dividerSize = 1;
                              __jade_nodes = __jade_nodes.concat(h("div", {
                                "class": {
                                  'bars-wrapper': true
                                },
                              }, (function() {
                                var __jade_nodes = [];
                                __jade_nodes = __jade_nodes.concat((function() {
                                  var $$obj = (step.data);
                                  var $$eachNodes;
                                  var $$iterated = false;
                                  if (Array.isArray($$obj)) {
                                    $$eachNodes = $$obj.reduce(function($$eachNodes, bar, barIdx) {
                                      $$iterated = true;
                                      return $$eachNodes.concat((function() {
                                        var __jade_nodes = [];
                                        __jade_nodes = __jade_nodes.concat(h("div", {
                                          "class": Object.assign({}, {
                                            'multi-bar': hasMultipleSeries
                                          }, {
                                            'bar-wrapper': true
                                          }),
                                        }, (function() {
                                          var __jade_nodes = [];
                                          const hasDropOff = !$attr(`disable-drop-off-viz`) && $helpers.hasDropOff(idx, barIdx, step);
                                          __jade_nodes = __jade_nodes.concat((hasMultipleSeries) ? ((function() {
                                            var __jade_nodes = [];
                                            const barHeight = Math.min(bar.convertedBarHeight + bar.dropOffBarHeight, 100);
                                            __jade_nodes = __jade_nodes.concat(h("div", {
                                              "style": {
                                                top: `calc(${100 - (barHeight)}% - 20px)`,
                                              },
                                              "class": {
                                                'count-text': true
                                              },
                                            }, [__vjadeSafeCode($helpers.abbreviateNumber3SigFigs(bar.value))]));;
                                            return __jade_nodes
                                          }).call(this)) : undefined);
                                          const {
                                            title,
                                            conversionCount,
                                            conversionPercentage,
                                            dropOffCount,
                                            dropOffPercentage,
                                            type,
                                            countType
                                          } = $helpers.getTooltipData(idx, barIdx, bar);
                                          const color = bar.color || $helpers.getColor(barIdx, $helpers.BarType.CONVERTED);
                                          __jade_nodes = __jade_nodes.concat((hasDropOff) ? ((function() {
                                            var __jade_nodes = [];
                                            __jade_nodes = __jade_nodes.concat(h("div", {
                                              "style": {
                                                height: `calc(${bar.dropOffBarHeight}% - ${dividerSize}px)`,
                                                bottom: `calc(${bar.convertedBarHeight}% + ${dividerSize}px)`,
                                                '--color': bar.color || $helpers.getColor(barIdx, $helpers.BarType.DROP_OFF),
                                              },
                                              "on": {
                                                click: $helpers.selectBar(idx, barIdx, $helpers.BarType.DROP_OFF),
                                                mousemove: ev => $helpers.handleMouseMove(idx, barIdx, $helpers.BarType.DROP_OFF, ev),
                                                mouseleave: $helpers.handleMouseLeave,
                                              },
                                              "class": Object.assign({}, {
                                                'selected': $helpers.isSelected(idx, barIdx, $helpers.BarType.DROP_OFF),
                                                'unselected': $helpers.isUnselected(idx),
                                                'is-not-clickable': $attr(`disable-drop-off-click`),
                                                'highlighted': $helpers.isHighlighted(idx, barIdx, $helpers.BarType.DROP_OFF),
                                                'has-drop-off': true,
                                                'multi-bar': hasMultipleSeries,
                                              }, {
                                                'drop-off-bar': true
                                              }),
                                            }, (function() {
                                              var __jade_nodes = [];
                                              __jade_nodes = __jade_nodes.concat(($helpers.shouldShowTooltip(idx, barIdx, $helpers.BarType.DROP_OFF) && dropOffCount) ? ((function() {
                                                var __jade_nodes = [];
                                                __jade_nodes = __jade_nodes.concat(jade_mixins['bar-tool-tip'].call(this, title, color, dropOffPercentage, dropOffCount, countType, $helpers.BarType.DROP_OFF, hoverTooltip.styles));;
                                                return __jade_nodes
                                              }).call(this)) : undefined);;
                                              return __jade_nodes
                                            }).call(this).filter(Boolean)));;
                                            return __jade_nodes
                                          }).call(this)) : undefined);
                                          __jade_nodes = __jade_nodes.concat(h("div", {
                                            "style": {
                                              height: `${bar.convertedBarHeight}%`,
                                              '--color': bar.color || $helpers.getColor(barIdx, $helpers.BarType.CONVERTED),
                                            },
                                            "on": {
                                              click: $helpers.selectBar(idx, barIdx, $helpers.BarType.CONVERTED),
                                              mousemove: ev => $helpers.handleMouseMove(idx, barIdx, $helpers.BarType.CONVERTED, ev),
                                              mouseleave: $helpers.handleMouseLeave,
                                            },
                                            "class": Object.assign({}, {
                                              'selected': $helpers.isSelected(idx, barIdx, $helpers.BarType.CONVERTED),
                                              'unselected': $helpers.isUnselected(idx),
                                              'is-not-clickable': $attr(`disable-step-click`),
                                              'highlighted': $helpers.isHighlighted(idx, barIdx, $helpers.BarType.CONVERTED),
                                              'has-drop-off': !hasDropOff,
                                              'multi-bar': hasMultipleSeries,
                                            }, {
                                              'bar': true
                                            }),
                                          }, (function() {
                                            var __jade_nodes = [];
                                            __jade_nodes = __jade_nodes.concat(($helpers.shouldShowTooltip(idx, barIdx, $helpers.BarType.CONVERTED)) ? ((function() {
                                              var __jade_nodes = [];
                                              __jade_nodes = __jade_nodes.concat(jade_mixins['bar-tool-tip'].call(this, title, color, conversionPercentage, conversionCount, countType, $helpers.BarType.CONVERTED, hoverTooltip.styles));;
                                              return __jade_nodes
                                            }).call(this)) : undefined);;
                                            return __jade_nodes
                                          }).call(this).filter(Boolean)));;
                                          return __jade_nodes
                                        }).call(this).filter(Boolean)));;
                                        return __jade_nodes
                                      }).call(this));
                                    }, []);
                                  } else {
                                    $$eachNodes = [];
                                    for (var $$objKey in $$obj) {
                                      (function() {
                                        var barIdx = $$objKey;
                                        if ($$obj.hasOwnProperty(barIdx)) {
                                          $$iterated = true;
                                          var bar = $$obj[barIdx];
                                          $$eachNodes = $$eachNodes.concat((function() {
                                            var __jade_nodes = [];
                                            __jade_nodes = __jade_nodes.concat(h("div", {
                                              "class": Object.assign({}, {
                                                'multi-bar': hasMultipleSeries
                                              }, {
                                                'bar-wrapper': true
                                              }),
                                            }, (function() {
                                              var __jade_nodes = [];
                                              const hasDropOff = !$attr(`disable-drop-off-viz`) && $helpers.hasDropOff(idx, barIdx, step);
                                              __jade_nodes = __jade_nodes.concat((hasMultipleSeries) ? ((function() {
                                                var __jade_nodes = [];
                                                const barHeight = Math.min(bar.convertedBarHeight + bar.dropOffBarHeight, 100);
                                                __jade_nodes = __jade_nodes.concat(h("div", {
                                                  "style": {
                                                    top: `calc(${100 - (barHeight)}% - 20px)`,
                                                  },
                                                  "class": {
                                                    'count-text': true
                                                  },
                                                }, [__vjadeSafeCode($helpers.abbreviateNumber3SigFigs(bar.value))]));;
                                                return __jade_nodes
                                              }).call(this)) : undefined);
                                              const {
                                                title,
                                                conversionCount,
                                                conversionPercentage,
                                                dropOffCount,
                                                dropOffPercentage,
                                                type,
                                                countType
                                              } = $helpers.getTooltipData(idx, barIdx, bar);
                                              const color = bar.color || $helpers.getColor(barIdx, $helpers.BarType.CONVERTED);
                                              __jade_nodes = __jade_nodes.concat((hasDropOff) ? ((function() {
                                                var __jade_nodes = [];
                                                __jade_nodes = __jade_nodes.concat(h("div", {
                                                  "style": {
                                                    height: `calc(${bar.dropOffBarHeight}% - ${dividerSize}px)`,
                                                    bottom: `calc(${bar.convertedBarHeight}% + ${dividerSize}px)`,
                                                    '--color': bar.color || $helpers.getColor(barIdx, $helpers.BarType.DROP_OFF),
                                                  },
                                                  "on": {
                                                    click: $helpers.selectBar(idx, barIdx, $helpers.BarType.DROP_OFF),
                                                    mousemove: ev => $helpers.handleMouseMove(idx, barIdx, $helpers.BarType.DROP_OFF, ev),
                                                    mouseleave: $helpers.handleMouseLeave,
                                                  },
                                                  "class": Object.assign({}, {
                                                    'selected': $helpers.isSelected(idx, barIdx, $helpers.BarType.DROP_OFF),
                                                    'unselected': $helpers.isUnselected(idx),
                                                    'is-not-clickable': $attr(`disable-drop-off-click`),
                                                    'highlighted': $helpers.isHighlighted(idx, barIdx, $helpers.BarType.DROP_OFF),
                                                    'has-drop-off': true,
                                                    'multi-bar': hasMultipleSeries,
                                                  }, {
                                                    'drop-off-bar': true
                                                  }),
                                                }, (function() {
                                                  var __jade_nodes = [];
                                                  __jade_nodes = __jade_nodes.concat(($helpers.shouldShowTooltip(idx, barIdx, $helpers.BarType.DROP_OFF) && dropOffCount) ? ((function() {
                                                    var __jade_nodes = [];
                                                    __jade_nodes = __jade_nodes.concat(jade_mixins['bar-tool-tip'].call(this, title, color, dropOffPercentage, dropOffCount, countType, $helpers.BarType.DROP_OFF, hoverTooltip.styles));;
                                                    return __jade_nodes
                                                  }).call(this)) : undefined);;
                                                  return __jade_nodes
                                                }).call(this).filter(Boolean)));;
                                                return __jade_nodes
                                              }).call(this)) : undefined);
                                              __jade_nodes = __jade_nodes.concat(h("div", {
                                                "style": {
                                                  height: `${bar.convertedBarHeight}%`,
                                                  '--color': bar.color || $helpers.getColor(barIdx, $helpers.BarType.CONVERTED),
                                                },
                                                "on": {
                                                  click: $helpers.selectBar(idx, barIdx, $helpers.BarType.CONVERTED),
                                                  mousemove: ev => $helpers.handleMouseMove(idx, barIdx, $helpers.BarType.CONVERTED, ev),
                                                  mouseleave: $helpers.handleMouseLeave,
                                                },
                                                "class": Object.assign({}, {
                                                  'selected': $helpers.isSelected(idx, barIdx, $helpers.BarType.CONVERTED),
                                                  'unselected': $helpers.isUnselected(idx),
                                                  'is-not-clickable': $attr(`disable-step-click`),
                                                  'highlighted': $helpers.isHighlighted(idx, barIdx, $helpers.BarType.CONVERTED),
                                                  'has-drop-off': !hasDropOff,
                                                  'multi-bar': hasMultipleSeries,
                                                }, {
                                                  'bar': true
                                                }),
                                              }, (function() {
                                                var __jade_nodes = [];
                                                __jade_nodes = __jade_nodes.concat(($helpers.shouldShowTooltip(idx, barIdx, $helpers.BarType.CONVERTED)) ? ((function() {
                                                  var __jade_nodes = [];
                                                  __jade_nodes = __jade_nodes.concat(jade_mixins['bar-tool-tip'].call(this, title, color, conversionPercentage, conversionCount, countType, $helpers.BarType.CONVERTED, hoverTooltip.styles));;
                                                  return __jade_nodes
                                                }).call(this)) : undefined);;
                                                return __jade_nodes
                                              }).call(this).filter(Boolean)));;
                                              return __jade_nodes
                                            }).call(this).filter(Boolean)));;
                                            return __jade_nodes
                                          }).call(this));
                                        }
                                      })();
                                    }
                                  }

                                  return $$eachNodes;
                                })());;
                                return __jade_nodes
                              }).call(this).filter(Boolean)));;
                              return __jade_nodes
                            }).call(this)) : undefined);;
                            return __jade_nodes
                          }).call(this).filter(Boolean)));;
                          return __jade_nodes
                        }).call(this));
                      }
                    })();
                  }
                }

                return $$eachNodes;
              })());;
              return __jade_nodes
            }).call(this).filter(Boolean)));;
            return __jade_nodes
          }).call(this)));;
          return __jade_nodes
        }).call(this).filter(Boolean)));;
        return __jade_nodes
      }).call(this).filter(Boolean)))
    };
  }.call(this, "$attr" in locals ? locals.$attr : typeof $attr !== "undefined" ? $attr : undefined, "$component" in locals ? locals.$component : typeof $component !== "undefined" ? $component : undefined, "$helpers" in locals ? locals.$helpers : typeof $helpers !== "undefined" ? $helpers : undefined, "Array" in locals ? locals.Array : typeof Array !== "undefined" ? Array : undefined, "JSON" in locals ? locals.JSON : typeof JSON !== "undefined" ? JSON : undefined, "Math" in locals ? locals.Math : typeof Math !== "undefined" ? Math : undefined, "Object" in locals ? locals.Object : typeof Object !== "undefined" ? Object : undefined, "String" in locals ? locals.String : typeof String !== "undefined" ? String : undefined, "hoverTooltip" in locals ? locals.hoverTooltip : typeof hoverTooltip !== "undefined" ? hoverTooltip : undefined, "smartHubDataPoint" in locals ? locals.smartHubDataPoint : typeof smartHubDataPoint !== "undefined" ? smartHubDataPoint : undefined));
  if (result_of_with) return result_of_with.value;
}
module.exports = _jade_template_fn;